
<main class="bg-brown">
  <div style="height: 20px !important;" class="bg-brown"></div>
 <app-navbar></app-navbar>
  <section class="py-6">
    <div class="container">
      <div class="row d-flex align-items-center">
        <div class="col-xxl-7 col-xl-7 col-lg-7 col-12 d-none d-md-block d-lg-block">
          <div class="mt-n22">
            <h1 class="display-2 fw-bold mb-3 text-dark">A TouchConnect Template To Suit Every Brand And Creator.</h1>
            <p class="lead mb-4 text-dark mb-3">Different Link Apps, integrations and visual styles can help you create a TouchConnect that looks and feels like you and your brand. Explore our library of custom templates to grow and connect with your audience even more easily.</p>
            <a routerLink="/login" class="btn btn-lg bg-dark py-3 rounded-4 text-white shadow px-5">Claim your TouchConnect</a>
          </div>
        </div>
        <div class="col-xxl-7 col-xl-7 col-lg-7 col-12 d-block d-md-none d-lg-none">
          <div >
            <h1 class="display-2 fw-bold mb-3 text-dark">Everything you are. In one, simple link in bio.</h1>
            <p class="lead mb-4 text-dark mb-4">Join TouchConnect to share all your content and products from Instagram, TikTok, Twitter, YouTube, and more with just one bio link.</p>
            <a routerLink="/login" class="btn btn-lg bg-dark py-3 rounded-4 text-white shadow px-5">Claim your TouchConnect</a>
          </div>
        </div>
        <div class="col-xxl-5  col-xl-5 col-lg-5 col-12 d-lg-flex justify-content-end">
          <div class="mt-1 mt-lg-0 position-relative">
            <img src="../../../assets/images/Linktree/media.avif" alt="online course"
              class="img-fluid box flip-scale-down-ver">

          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="py-6 bg-white">
    <div class="container">
      <div class="row">
        <div class="col-xxl-4 col-xl-4 col-lg-4 col-12">
          <h6 class="display-6 fw-bold mb-3 text-dark">Browse by</h6>
          <button class="btn btn-default shadow mb-3 mx-1">
            Fashion
          </button>
          <button class="btn btn-default shadow mb-3 mx-1">
            Health and Fitness
          </button>
          <button class="btn btn-default shadow mb-3 mx-1">
            Influencer and Creater
          </button>
          <button class="btn btn-default shadow mb-3 mx-1">
            Marketing
          </button>
          <button class="btn btn-default shadow mb-3 mx-1">
            Music
          </button>
          <button class="btn btn-default shadow mb-3 mx-1">
            Small Busines
          </button>
          <a routerLink="/login" class="btn btn-lg bg-dark py-3 rounded-4 text-white shadow px-5">Claim your TouchConnect</a>
        </div>

        <div class="col-xxl-8  col-xl-8 col-lg-8 col-12 ">
          <div class="row">
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F5.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F6.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>



            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F7.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F8.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F9.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>


            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F10.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F12.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F13.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>

            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F14.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F15.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
            <div class="col-lg-4">
              <img src="../../../assets/images/Linktree/templates/F16.png" alt="" class="img-fluid">
              <h3>Template1</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<footer class="pt-lg-10 pt-5 footer bg-white">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <!-- about company -->
        <div class="mb-4">
          <img src="../../../assets/images/Linktree/Frame.png" alt="" class="navbar-brand ">
          <div class="mt-4">
            <p>Our experienced experts are available by phone and email to answer all your questions.
              To understand our services, find the right support or simply subscribe to an offer, do not hesitate to contact them.</p>
            <!-- social media -->
            <div class="fs-4 mt-4">
              <a href="#" class="mdi mdi-facebook fs-4 text-muted me-2"></a>
              <a href="#" class="mdi mdi-twitter text-muted me-2"></a>
              <a href="#" class="mdi mdi-instagram text-muted "></a>
            </div>
          </div>
        </div>
      </div>
      <div class="offset-lg-1 col-lg-2 col-md-3 col-6">
        <div class="mb-4">
          <!-- list -->
          <h3 class="fw-bold mb-3">Reach Us</h3>
          <ul class="list-unstyled nav nav-footer flex-column nav-x-0">

            <li><a routerLink="/showPosts" class="nav-link">Blog</a></li>
            <li><a routerLink="/showPosts" class="nav-link">Map</a></li>
            <li><a routerLink="/contact" class="nav-link">Contact</a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-6">
        <div class="mb-4">
          <!-- list -->
          <h3 class="fw-bold mb-3">Company</h3>
          <ul class="list-unstyled nav nav-footer flex-column nav-x-0">
            <li><a routerLink="/contact" class="nav-link">Privacy Policy</a></li>
            <li><a routerLink="/contact" class="nav-link">Disclaimer</a></li>
            <li><a routerLink="/contact" class="nav-link">Terms and Conditions</a></li>
            <li><a routerLink="/contact" class="nav-link">About us</a></li>


          </ul>

        </div>
      </div>
      <div class="col-lg-3 col-md-12">
        <!-- contact info -->
        <div class="mb-4">
          <h3 class="fw-bold mb-3">Get in touch</h3>
          <p>339 McDermott Points Hettingerhaven, NV 15283</p>
          <p class="mb-1">Email: <a href="#">supportmtyiazsui.com</a></p>
          <p>Phone: <span class="text-dark fw-semibold">(000) 123 456 789</span></p>

        </div>
      </div>
    </div>
    <div class="row align-items-center g-0 border-top py-2 mt-6">
      <!-- Desc -->
      <div class="col-lg-4 col-md-5 col-12">
        <span>© <span id="copyright2">
            <script>document.getElementById('copyright2').appendChild(document.createTextNode(new Date().getFullYear()))</script>
          </span>TouchConnect, Inc. All Rights Reserved</span>
      </div>

      <!-- Links -->
      <div class="col-12 col-md-7 col-lg-8 d-md-flex justify-content-end">

      </div>
    </div>
  </div>
</footer>
